// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import Notifications from '@material-ui/icons/Notifications';
import Badge from './Badge';
import loadNotifications from '../state/loadNotifications';
import getNotificationCounts from '../api/getNotificationCounts';
import markNotificationsAsViewed from '../state/markNotificationsAsViewed';
import { getStore } from '../../../state/store';
import * as AppState from '../../../state/reducer/app/appState';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import Console from '../../../lib/debug';

const MINUTE_IN_MS = 60000;

class NotificationButton extends PureComponent {
    constructor(props: any) {
        super(props);
        this.pollInterval = null;
        this.state = { badgeCount: 0 };
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.fetchNotificationCount();

        this.pollInterval = setInterval(() => {
            this.fetchNotificationCount();
        }, MINUTE_IN_MS);
    }

    componentWillUnmount() {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
    }

    async fetchNotificationCount() {
        const response = await getNotificationCounts();
        const countNotViewed = response
            ? response.countNotificationNotViewed
            : 0;
        if (countNotViewed > this.state.badgeCount) {
            getStore().dispatch(loadNotifications());
        }

        this.setState({
            badgeCount: countNotViewed
        });
    }

    onClick() {
        SegmentService.track(SEGMENT_EVENTS.ClickCTA.key, {
            sources: 'Web app',
            ctaLocation: 'Main Nav',
            ctaText: 'Bell Icon'
        });
        getStore().dispatch(loadNotifications());
        this.setState({ badgeCount: 0 }, () => {
            getStore().dispatch(markNotificationsAsViewed());
            AppState.navigate('/notifications');
        });
    }

    render() {
        Console.render('NotificationButton');
        return (
            <IconButton
                className="notification-link"
                aria-label="Notification Bell"
                onClick={this.onClick}
            >
                <Notifications className="notification-bell" />
                {this.state.badgeCount > 0 ? (
                    <Badge count={this.state.badgeCount} />
                ) : null}
            </IconButton>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        features: state.features
    };
};

NotificationButton = connect(mapStateToProps)(NotificationButton);

export default NotificationButton;



// WEBPACK FOOTER //
// ./src/v5/notifications/components/NotificationButton.jsx